import { createEntityAdapter, EntityState } from '@reduxjs/toolkit';

import { baseApi } from './base';
import { LegalDocument } from '../domain/config';

const legalDocumentAdapter = createEntityAdapter<LegalDocument>({ selectId: (doc: LegalDocument) => doc.key });
const initialState = legalDocumentAdapter.getInitialState();

export const legalDocumentsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getLegalDocuments: builder.query<EntityState<LegalDocument>, void>({
      query: () => ({
        method: 'GET',
        url: 'qualification/legal-documents',
      }),
      transformResponse(response: LegalDocument[]) {
        return legalDocumentAdapter.setAll(initialState, response);
      },
    }),
  }),
});

export const { useGetLegalDocumentsQuery } = legalDocumentsApi;
